import { Pipe, PipeTransform } from "@angular/core";
import Autolinker from "autolinker";

// eslint-disable-next-line @angular-eslint/pipe-prefix
@Pipe({
    name: "linkified",
    standalone: false
})
export class LinkifiedPipe implements PipeTransform {
    transform(str: string): string {
        return str ? Autolinker.link(str, { newWindow: true, stripPrefix: false }) : "";
    }
}
